export default __webpack_public_path__ + "static/media/removeIcon.a65bc0b1.svg";